import { CLIENT_URL } from "../config/api";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer shadow">
      <nav className="footer-nav">
        <ul className="footer-list">
          <li className="footer-item">
            <a href={`${CLIENT_URL}/help`} target={'_blank'} className="footer-link">
              Вопросы?
            </a>
          </li>
          <li className="footer-item">
            <a href="https://nsis.ru/products/osago/check/" target={'_blank'} className="footer-link">
              Поиск ОСАГО в РСА
            </a>
          </li>
          <li className="footer-item">
            <a href={`${CLIENT_URL}/contracts`} target={'_blank'} className="footer-link">
              Наши партнеры
            </a>
          </li>
          <li className="footer-item">
            <a href={`${CLIENT_URL}/docs/privacy-policy`} target={'_blank'} className="footer-link">
              Политика конфиденциальности
            </a>
          </li>
        </ul>
      </nav>
      <div className="footer-contacts">
        (с) {year}, Blockchain LLC, OOO “Блокчейн”, 390006, Рязань, <br />
        пл. 26 Бакинских комиссаров, 6/21, пом. Н1, ИНН 6234181385, ОГРН 1186234018442
      </div>
    </footer>
  );
};

export default Footer;
